import { NextSeo, QAPageJsonLd } from 'next-seo';

import { QuestionV2 } from '~/lib/discussions/types';
import { Deal } from '~/types/deal';
import { firstSentence, lastWordAt } from '~/lib/util';
import { getQuestionPageLDSchema } from '~/lib/util/schemaLD';

export function QuestionSeo({
  question,
  deal,
}: {
  question: QuestionV2;
  deal: Deal;
}) {
  const questionTitle = question.title || question.comment;
  const title = questionTitle
    ? `${firstSentence({ text: questionTitle, maxLength: 60 })} | ${
        deal.public_name
      }`
    : `${deal.public_name}`;
  const description = lastWordAt(question.comment || question.title || '');
  const questionJSONLD = getQuestionPageLDSchema(question, deal);

  return (
    <>
      <NextSeo title={title} description={description} />
      <QAPageJsonLd {...questionJSONLD} />
    </>
  );
}
